import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { setSelectedProduct } from '../data/guaranteePurchases/actions';
import {
  PRODUCT_FAMILY_SA,
  PRODUCT_FAMILY_ALL,
} from '../constants/productFamily';
import { GUARANTEES_V2_ENABLED } from '../config';

const selectGuaranteePurchases = state => state.data.guaranteePurchases;

export const useGuaranteeProduct = () => {
  const { selectedProduct } = useSelector(selectGuaranteePurchases);
  const dispatch = useDispatch();
  const setProduct = useCallback(
    productId => {
      dispatch(setSelectedProduct(productId));
    },
    [dispatch]
  );
  return [selectedProduct, setProduct];
};

export const useGuaranteeTheme = () => {
  const [selectedProduct] = useGuaranteeProduct();

  const themeClass = useMemo(() => {
    if (!GUARANTEES_V2_ENABLED) return '';

    let specific = 'theme-blue';
    if (selectedProduct === PRODUCT_FAMILY_SA) specific = 'theme-green';
    else if (selectedProduct === PRODUCT_FAMILY_ALL) specific = 'theme-graphite';

    return `theme ${specific}`;
  }, [selectedProduct]);

  return themeClass;
};
